export default __webpack_public_path__ + "static/media/Thousand_Eyes_On_Me_logo.3a5008a7.png";